import React, { useState, useEffect } from 'react';
import CourseCard from '../cards/CourseCard';
import EmptyResults from '../common/EmptyResults';
import { useSearch } from '../../contexts/SearchContext';
import { useUser } from '../../contexts/UserContext';
import SpinnerOverlay from '../ui/SpinnerOverlay';
import Pagination from './Pagination';

const ResultsSection = ({ onShowSchedule, onViewSyllabus }) => {
  const {
    filteredCourses,
    page,
    limit,
    total,
    goToPage,
    loadingCourses,
    handleRegister,
    isCourseRegistered,
    resetSearch,
  } = useSearch();

  const { showAlert } = useUser();
  const [isRegistering, setIsRegistering] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);

  const totalPages = Math.max(1, Math.ceil((total || 0) / (limit || 1)));

  useEffect(() => {
    if (!loadingCourses) {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }, [page, loadingCourses]);

  const handlePageChange = (value) => {
    if (value < 1 || value > totalPages || value === page) return;
    goToPage(value);
  };

  const onRegister = async (id) => {
    setIsRegistering(true);
    try {
      await handleRegister(id);
      showAlert('ההרשמה לקורס בוצעה בהצלחה', 'success');
    } catch (err) {
      showAlert(err.message);
    } finally {
      setIsRegistering(false);
    }
  };

  if (loadingCourses || isRegistering) {
    return (
      <SpinnerOverlay
        variant="glow"
        text="נא להמתין"
        dark={false}
        blur={false}
      />
    );
  }

  if (!filteredCourses.length) {
    return <EmptyResults resetSearch={resetSearch} />;
  }

  return (
    <div dir="rtl">
      
      <div className="flex items-center justify-between mb-3.5 px-0.5">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center justify-center min-w-[30px] h-[22px] px-2 bg-gradient-to-br from-indigo-500 to-violet-600 text-white text-[0.75rem] font-bold rounded-full shadow-sm shadow-indigo-200">
            {total || filteredCourses.length}
          </span>
          <span className="text-[0.85rem] text-gray-500 font-medium">
            קורסים זמינים להרשמה
          </span>
        </div>

        { totalPages  > 1 && 
          <span className="text-sm text-gray-500 font-medium">
            עמוד {page} מתוך {totalPages}
          </span>
        }

      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(min(360px, 100%), 1fr))',
          gap: '20px',
        }}
      >
        {filteredCourses.map((course) => (
          <CourseCard
            key={course.id}
            course={course}
            onClick={() => onRegister(course.id)}
            isRegistered={isCourseRegistered(course.id)}
            search={true}
            isMenuOpen={openMenuId === course.id}
            onMenuOpen={() => setOpenMenuId(course.id)}
            onMenuClose={() => setOpenMenuId(null)}
            onShowSchedule={onShowSchedule}
            onViewSyllabus={onViewSyllabus}
          />
        ))}
      </div>

      <div className="flex justify-start mt-5 mb-4">
        <Pagination
          page={page}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default ResultsSection;